module.exports = __webpack_public_path__ + "img/hiw_img04.dc6a8bcb.png";